// 会员协议
let member = {
  title: '云柑社区会员服务协议',
  content:[
    {
      text: '协议的版本及生效日期',
      subText: [
        {text: '《云柑社区会员服务协议》于2019年2月1日起生效，最新版本更新时间：2021年7月26日'}
      ]
    },
    {
      text: '欢迎您使用云柑社区会员服务!',
      subText: [
        {text: '“云柑社区会员服务”是指“云柑社区”为云柑社区会员提供的相关服务。您可以通过注册您的“云柑社区”账户（以下统称“您的账户”），并在“云柑社区”移动端软件（以下统称“我们的软件”）登录，从而使用我们的会员服务。'},
        {text: '“云柑社区”，定位于一个有文化温度的社区，使用5G、人工智能、区块链、大数据等高新技术，集成了云柑社区、云柑访客、云柑名片、云柑5G云店、云柑组织等应用服务，为数字乡村/生活社区等打造乡村数字化、城乡融合、同镇生活圈、社区网格化服务的社区数字生态平台（以下统称为“本平台”），赋能乡村振兴和城乡融合。了解和熟悉产品的功能和设置，并根据自身情况进行设置调整，避免发生您的信息被滥用，是您自己的责任。我们欢迎您向我们反馈使用体验和改进隐私保护与产品需求/用户需求之间的平衡的可操作性建议。'},
        {text: '感谢您选择“云柑社区”，《云柑社区会员服务协议》是由惠州市脉链科技有限公司（以下简称“我们”）与您签订。“您”是指云柑社区会员服务的使用者。“云柑社区会员”包含普通会员、银牌会员、金牌会员。'},
        {text: '除本协议外，我们发布的《云柑社区用户协议》和其他业务规则也是本协议的一部分，请您仔细阅读以下条款，如果您对本协议的任何条款表示异议，您可以选择不注册“云柑社区”。'},
      ]
    },
    {
      text: '一、云柑社区会员类型及权益',
      subText: [
        {text: '1、会员类型：云柑社区会员包含普通会员、银牌会员、金牌会员三个等级。普通用户下载注册即免费成为云柑社区会员，享受注册和邀请奖励，可以是个人或企业用户。'},
        {
          text: '2、普通会员权益：',
          subText: [
            {text: '（1）注册即可获得10枚云柑积分；'},
            {text: '（2）邀请直属一级会员获10枚云柑积分；'},
            {text: '（3）获得直属一级会员平台收益佣金（6%）。'},
          ]
        },
        {
          text: '3、银牌会员权益：',
          subText: [
            {text: '（1）邀请直属一级会员获10枚云柑积分；'},
            {text: '（2）获得直属一级会员平台收益佣金（8%）。'},
          ]
        },
        {
          text: '4、金牌会员权益：',
          subText: [
            {text: '（1）邀请直属一级会员获10枚云柑积分；'},
            {text: '（2）获得直属一级会员平台收益佣金（10%）。'},
          ]
        },
      ]
    },
    {
      text: '二、如何成为云柑社区会员',
      subText: [
        {text: '1、首先请确认您同意《云柑社区用户协议》中的各项规定，并且已经成功注册成为“云柑社区”的用户，即免费成为普通会员，并获得相关的会员权益。'},
        {
          text: '2、会员升级规则：',
          subText: [
            {img: 'https://fileqn.anttalk.vip/member20201110/yungansheqvhuiyuan.png',style: 'width: 100%;'},
            {text: '（1）直推100个普通会员可自动升级成银牌会员；'},
            {text: '（2）直推1000个普通会员可自动升级成金牌会员；'},
            {text: '（3）升级规则会根据平台运营需要进行调整，不作另行通知。'},
          ]
        },
      ]
    },
    {
      text: '三、会员使用规范',
      subText: [
        {text: '1、云柑社区会员可以在云柑5G云店中开设知识店、商品店、服务店，请诚信经营，未经许可不得侵犯第三者的商标或其他权益。'},
        {text: '2、云柑社区会员须同样遵守《云柑社区用户协议》中的“用户行为规范”，本协议不一一列举。'},
        {text: '3、因为您违反本协议规定的行为而对“云柑社区”造成的损失，包括但不限于因您的行为导致或产生的任何第三方主张的任何索赔、要求或损失，以及我们处理这些事务的必要支出，例如律师费等，您同意赔偿“云柑社区”的上述损失，并使之免受损害。'},
      ]
    },
    {
      text: '四、责任限制',
      subText: [
        {text: '1、请您从我们提供的官方途径购买云柑5G云店服务，否则，我们无法保证您的账户的安全性及合法权益。对于因使用未经授权的账户对您或第三方造成的损失，我们不承担任何责任。'},
        {
          text: '2、您完全理解，由于本平台会员服务属于互联网性质，可能会遇到各种不可抗力等风险因素，使相关服务发生中断。我们将努力及时修复，但是由此给您造成的一切损失须自行承担，我们不予负责。这些意外风险包括但不限于如下原因导致的服务中断和受阻：',
          subText: [
            {text: '（1）受到计算机病毒、木马或其他恶意程序、黑客攻击的破坏；'},
            {text: '（2）用户或我们的终端设备软件、系统、硬件和通信线路出现故障；'},
            {text: '（3）意外事件、自然灾害或政府行为；'},
            {text: '（4）用户使用非经我们提供或授权提供的服务；'},
            {text: '（5）其他不可抗力或我们无法控制的因素。'},
          ]
        },
        {text: '3、我们对无法合理预知和不可控制的产品技术瑕疵、服务的稳定性以及由此产生的任何损失或损害不作任何形式的担保，但法律法规另有规定的除外。'},
        {text: '4、若您的账户在不能正常使用期间产生任何直接或间接损失，我们不承担任何直接或间接的法律责任。'},
      ]
    },
    {
      text: '五、会员服务的终止',
      subText: [
        {text: '1、您可以随时终止使用云柑社区会员服务，注销云柑社区账号，但已售出的云店服务概不退还任何费用。'},
        {
          text: '2、如发生下列任何一种情形，我们有权不经通知终止向您提供我们的服务：',
          subText: [
            {text: '（1）您提供的会员信息不准确，不真实或不合法有效；'},
            {text: '（2）您违反本协议的规定；'},
            {text: '（3）按照法律规定或主管部门的要求；'},
            {text: '（4）其他必要的情形。'},
          ]
        },
      ]
    },
    {
      text: '六、法律适用与管辖',
      subText: [
        {text: '因本协议的成立、生效、履行或与之有关的解释及纠纷的解决，适用于中华人民共和国大陆地区法律（不包括冲突法）；若您和“云柑社区”之间发生任何纠纷或争议，首先应友好协商解决；协商不成的，您同意纠纷或争议由“云柑社区”注册地法院管辖。'},
        {text: '本协议的所有条款仅仅是为了醒目及阅读方便，本身并无实际涵义，不能作为本协议涵义解释之依据。'},
      ]
    },
    {
      text: '七、其他',
      subText: [
        {text: '我们欢迎您就我们的服务提出反馈，除非另有明确声明，您发送的任何反馈内容将被视为无需保密的内容，您同意我们可以自行决定是否公开、发表，您同意授权我们无偿使用，并可以根据具体情况进行修改、改编、调整设计、变更技术方案，或者根据我们的需求进行其他改动。'},
        {text: '如果您对我们的服务或本用户协议有任何意见或建议，可通过客服与我们联系，我们会尽可能的给予您及时而必要的帮助。'},
        {text: '本协议解释权及修订权归“云柑社区”所有。根据国家法律法规变化及平台运营需要，“云柑社区”有权以公告的方式进行不定期地制定、修改本协议或相关服务规则，暂停、取消和修改本协议条款，修改后的协议一旦被公告在平台上即生效，并代替原来的协议。用户应及时关注不时发布的各项服务规则及本协议的变更。若不同意相关规则及条款修改的，应及时终止与本平台的协议。如用户继续使用本平台服务，即视为同意更新后的协议。'},
      ]
    },
    
  ]
}
export default member